import Footer from 'components/Footer';
import OrganizationHeader from 'components/OrganizationHeader';
import ScrollTop from 'src/components/ScrollTop';

type HotelLayoutProps = {
   children: any;
   isLoading: boolean | undefined;
};

const HotelLayout = (props: HotelLayoutProps) => {
   const { children } = props;

   return (
      <div className="min-h-screen flex flex-col justify-between items-center bg-white">
         <ScrollTop />
         <OrganizationHeader />
         {children}
         <Footer />
      </div>
   );
};

export default HotelLayout;
